export type UrlFields = {
  planTypeName: string;
  zipcode: string;
  county: string;
  year: string;
  planName: string | number | undefined;
  contract: string | number | undefined;
  pbp: string | number | undefined;
  groupID: string | number | undefined;
  crmPrefix: string;
  mcProductID: string | undefined;
  cta: string;
};
